module.exports = __webpack_public_path__ + "img/pdf.5a73776c.svg";